/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientNotFoundCard/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import ReplacePatient from './ReplacePatient/index'
import TysiaIconClose from 'DesignSystem/Svgs/TysiaIconClose/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientNotFoundCard({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/Content/PatientNotFoundCard",
  onReplaceMatch
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="PatientNotFoundCard.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z2tq8QD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Z2tq8QD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-Z2tq8QD': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-Z2tq8QD': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-Z2tq8QD': dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PatientNotFoundCard.Vertical"
  data-view-path={viewPath}
 style={{'--bc-5-Z2tq8QD': dtColorsNeutral200,'--btlr-6-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--btrr-7-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bblr-8-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--bbrr-9-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--h-10-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--w-11-Z2tq8QD': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconClose
  viewPath={`${viewPath}/TysiaIconClose`}
 fill={dtColorsNeutral500}
 width={dtSpaceS}
 height={dtSpaceS}
/>
</div>
<ReplacePatient
  viewPath={`${viewPath}/ReplacePatient`}
 onReplaceMatch={onReplaceMatch}
/>
</div>
{children}
</React.Fragment>)
}